import React, { useState } from 'react'
import { gql, useMutation } from '@apollo/client'
import { Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material'
import { T } from './onboardingDesign'
import { GhostButton, Notice, PrimaryButton } from './onboardingUi'

const DELETE_SIGNUP = gql`
  mutation DeletePartnerSignup($id: ID!) {
    deletePartnerSignup(id: $id)
  }
`

/**
 * Asks before deleting a signup. Only ones never signed or onboarded
 * (row.canDelete); the backend refuses the rest.
 *
 *   row        the signup to delete, or null when closed
 *   onClose    cancelled
 *   onDeleted  it is gone
 */
export default function DeleteSignupDialog({ row, onClose, onDeleted }) {
  const [remove, { loading }] = useMutation(DELETE_SIGNUP)
  const [error, setError] = useState(null)
  const close = () => {
    if (loading) return
    setError(null)
    onClose()
  }
  const confirm = () => {
    setError(null)
    remove({ variables: { id: row._id } })
      .then(() => onDeleted(row))
      .catch(e => setError(e.message))
  }
  return (
    <Dialog open={!!row} onClose={close} maxWidth="xs" fullWidth>
      {row && (
        <>
          <DialogTitle>Delete this signup?</DialogTitle>
          <DialogContent dividers sx={{ borderColor: T.divider }}>
            {error && <Notice severity="error">{error}</Notice>}
            <Typography sx={{ color: T.text2, fontSize: 14.5, lineHeight: 1.6 }}>
              <strong style={{ color: T.text }}>{row.restaurantName || 'Untitled'}</strong>
              {row.startedByName ? `, started by ${row.startedByName},` : ''} will be deleted with its answers,
              uploaded documents and fee requests. A link already emailed to the restaurant stops working.
              This can’t be undone.
            </Typography>
          </DialogContent>
          <DialogActions sx={{ px: 3, py: 2, gap: 1 }}>
            <GhostButton onClick={close} disabled={loading}>Cancel</GhostButton>
            <PrimaryButton busy={loading} onClick={confirm}>Delete</PrimaryButton>
          </DialogActions>
        </>
      )}
    </Dialog>
  )
}
